import React, { Component } from 'react';
import { animations } from 'react-animation';
import { connect } from 'react-redux';
class WeexModalAtividades extends Component {

    state = {
        visivel:true,
        imagem: "./fatooufake_popup.png",
        titulo: "",
        texto: ""
    }

    info = new Map(
        [
            [
                "fatofake", 
                {
                    titulo: "FATO OU FAKE", imagem: "./fatooufake_popup.png", texto: "Desafio de perguntas e respostas para você aprender brincando."
                }
            ], 
            [
                "video", 
                {
                    titulo: "VIDEOS", imagem: "./videos_popup.png", texto: "Vídeos curtos a cada dia. Conhecimento prático e vivencial para informar e inspirar."
                }
            ], 
            [
                "game", 
                {
                    titulo: "GAME", imagem: "./jogos_popup.png", texto: "Jogos com enredos de saúde - uma dose de diversão e competição amigável para a sua semana!"
                }
            ], 
            [
                "extra", 
                {
                    titulo: "EXTRA", imagem: "./calendario_contorno.png", texto: "Conteúdo extra. Conteúdo inédito para você se surpreender!"
                }
            ], 
            [
                "novoshabitos", 
                {
                    titulo: "NOVOS HÁBITOS", imagem: "./novos-habitos.png", texto: "Oportunidades diárias de se comprometer com comportamentos e atitudes que fazem a diferença."
                }
            ]
        ]
    )

    constructor(props) {
        super(props)
        
        let imagem = this.info.get(props.atividade).imagem
        let titulo = props.i18n.message("dinamica." + props.atividade + ".nome", this.info.get(props.atividade).titulo)
        let texto = props.i18n.message("dinamica." + props.atividade + ".ajuda", this.info.get(props.atividade).texto)
        this.state = {visivel:props.atividade != null, imagem: imagem, 
                    titulo: titulo, texto: texto, i18n: props.i18n}
        
    }

    

    ocultar = (event) => {
        this.props.callback()
    }

    render() {
        let i18n = this.props.i18n
        return (
            <div className={this.state.visivel === true ? 'modal is-active' : 'modal'} style={{animation: animations.popIn}}>
                <div className="modal-background weex-modal-background"></div>
                <div className="modal-card weex-modal-card">
                    <header className="modal-card-head weex-modal-card-header">
                        <p className="modal-card-title wex-modal-card-title">
                            <img src={this.state.imagem} alt="" className="image is-48x48"/>
                            {this.state.titulo}
                        </p>
                        <button onClick={this.ocultar} className="delete is-large" aria-label="close"></button>
                    </header>
                    <section className="modal-card-body has-text-centered">
                        <div className="weex-modal-card-body__texto">
                            {this.state.texto}
                        </div>
                        <button className="weex-button weex-button__modal" onClick={this.ocultar}>{i18n.message("geral.entendi", "ENTENDI!")}</button>
                    </section>
                </div>
            </div>
        )
    }
}

const mapStateToProps = function(state) {
    return {
        i18n:state.i18n
    }
}

export default connect(mapStateToProps)(WeexModalAtividades)